import React from 'react';
import { ContentCopy } from '@mui/icons-material';
import { IconButton, Tooltip, tooltipClasses } from '@mui/material';
import { grey } from '@mui/material/colors';

import { toast } from '../../util/toast';

type Props = {
  copyString: string;
  title?: string;
};

const CopyButton = ({ title = 'text', copyString }: Props) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(copyString).then(() => {
      toast.info(`The ${title} has been copied to your clipboard`);
    });
  };

  return (
    <IconButton onClick={handleCopy} size="small">
      <Tooltip
        title={`Copy ${title}`}
        placement="top"
        componentsProps={{
          popper: {
            sx: {
              [`& .${tooltipClasses.tooltip}`]: {
                backgroundColor: 'white',
                color: 'black',

                border: `1px solid ${grey[300]}`,
              },
            },
          },
        }}
      >
        <ContentCopy sx={{ fontSize: '16px', color: 'link.main', margin: 0.5 }} />
      </Tooltip>
    </IconButton>
  );
};

export default CopyButton;
